import { CloseOutlined } from '@ant-design/icons'
import React from 'react'

function Warning({setWarning}) {
  return (
    <section onClick={() => {setWarning(false)} }  className=" p-2 rounded-xl relative duration-75 top-18 left-0 z-[100] bg-white">
    <div className="border-dashed border-2 rounded-lg p-2 font-body  ">
      <div className="absolute top-3 left-4 text-red-600"><CloseOutlined/> </div>
      
        <p className="p-2 animate-pulse text-[#255555]">
          
          
          کارشناس گرامی، جهت ویرایش هر بخش میتوانید بر روی آن ضربه بزنید.
        </p>
      
    </div>
  </section>
  )
}

export default Warning